export default __webpack_public_path__ + "static/media/MCB Cheque.b7397a02.jpg";